import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import sizes from 'themes/sizes';

export default styled.span`
  ${sizes};
  font-size: 24px;
  color: ${(props) => props.theme.colors.text.textColorDark};
  ${ifProp(
    'center',
    css`
      text-align: center;
      width: 100%;
    `
  )}
`;
